import { Config } from 'config';

import { assign, defaults } from 'lodash';

import { dot } from 'gear';

import { Matrix, Frame, designLayersFrom, Figures,
         docIslandsFrom, docToModelMatrix,
         textureIslandName } from 'cdl';

import { TextureComposition, Plugin } from '../view';

const { filterProcessed } = Figures;


function processedDocIslandsFor( page, modelIsland ) {
  // filterProcessed( filter( docIslandsFrom(page), isDocIslandFor(modelIsland) ) );
  const modelIslandName = textureIslandName(modelIsland);
  const pageDocIslands = docIslandsFrom(page);
  const docIslands = [];
  for( let pdi = 0, pdiEnd = pageDocIslands.length; pdi < pdiEnd; ++pdi ) {
    const island = pageDocIslands[pdi];
    if( island.processed() && textureIslandName(island) === modelIslandName ) {
      docIslands.push( island );
    }
  }
  return docIslands;
}

export const TextureViewComposition = TextureComposition.extend({ typeName: 'TextureViewComposition',

  clearComposedCanvas() {
    if( ! this.canvas3D ) { // No need to clear the canvas in case the texture is used for a canvas3D
      this.callParent();
    }
  },

  // Overwrite drawPlugin to add the logic of rendering each plugin
  // once for every texture island
  drawPlugin( view, plugin, name, context ) {



    if( ! view._modelReady ){
      return; // There isn't a Doc3D properly loaded yet
    }

    if( ! plugin.somethingToDraw() ) {
      return; // Optimization
    }

    const { model } = view;
    const { target } = plugin;

    if( target === 'view' || target === 'model' ) {

      this.callParent(view,plugin,name,context);

    }
    else {

      const transformModel = view.getViewPortTransform();

      const drawConfig = view.drawConfig();

      const { modelIslands } = model;
      for( let i = 0, iEnd = modelIslands.length; i < iEnd; ++ i ) {
        const modelIsland = modelIslands[i];

        const config = assign({ view, context, transformModel, modelIsland },drawConfig);

        context.save();

        if( ! Config.clipTest1 ) {
          const bleedModelIsland = model.bleedModelIslandWithName(textureIslandName(modelIsland));
          bleedModelIsland.polyregions[0].clipContext(context,transformModel);
        }

        if( target === 'textureIslands' ) {

          // The draw function is called once for every texture island clipped to it
          this.drawPlugin2D(view,plugin,name,assign({
            transform: transformModel
          },config));

        }
        else { // target === 'document'

          const { pages } = view;
          for( let p = 0, pEnd = pages.length; p < pEnd; ++p ) {
            const page = pages[p];

            const docIslands = processedDocIslandsFor(page,modelIsland);

            for( let d = 0, dEnd = docIslands.length; d < dEnd; ++d ) {
              const docIsland = docIslands[d];

              // Optimization, no need to draw the plugin if it doesn't overlap with this docIsland
              if( plugin.needsToDrawFor( docIsland ) ) {

                const transformDoc = Matrix.m( transformModel, docToModelMatrix(docIsland,modelIsland) );

                // The draw function is called, once for every pair texture island <-> docisland
                this.drawPlugin2D(view,plugin,name,assign({
                  docIsland,
                  transformDoc,
                  transform: transformDoc
                },config));
              }
            }
          }
        }

        context.restore(); // Remove clipping
      }
    }
  }

});


Plugin.TextureViewRenderer = Plugin.extend({ typeName: 'TextureViewRendererPlugin',

  name: 'renderer',

  drawTo_color: ['document'],

  // The draw function will be called, once for every texture island and all
  // drawing will be clipped to it.
  // We need to do it like this to respect the z-order of figures
  target: 'textureIslands',

  redrawFigure( /*view,figure*/) {
    this.redraw();
  },

  draw( config ) {

    const { view, context, transformModel, modelIsland } = config;
    const { doc } = view;

    // First draw the islands background, using the top most island across all pages
    // Transparent brushes will show the color texture underneath
    {
      const backgroundDocIsland = doc.topDocIslandFor(modelIsland);
      if( backgroundDocIsland && backgroundDocIsland.processed() ) {
        const transformDoc = Matrix.m( transformModel, docToModelMatrix(backgroundDocIsland,modelIsland) );
        const { brush } = backgroundDocIsland.polyregions[0];
        if( ! ( brush._empty || ( brush.typeName === 'Brush' && brush.color.alpha === 0 ) ) ) {
          view.figureView( backgroundDocIsland ).draw( context, transformDoc, defaults({ transformDoc, ignorePen: true }, config ) );
        }
      }
    }

    // Then draw all the figures, respecting their z-order in their layers and
    // between pages. The last page will have the top most figures

    const { pages } = doc;
    for( let p = 0, pEnd = pages.length; p < pEnd; ++p ) {
      const page = doc.pages[p];

      const docIslands = processedDocIslandsFor(page,modelIsland);

      const designLayers = designLayersFrom(page);
      for( let l = 0, lEnd = designLayers.length; l < lEnd; ++l ) {
        const layer = designLayers[l];

        layer.beforeDraw(context,config);

        const figures = filterProcessed(layer.figures);

        for( let i = 0, iEnd = figures.length; i < iEnd; ++i ) {
          const figure = figures[i];

          for( let di = 0, diEnd = docIslands.length; di < diEnd; ++di ) {
            const docIsland = docIslands[di];

            // Optimization, no need to draw the figure if it doesn't overlap with this docIsland
            if( Frame.areOverlapping( docIsland.frame_(), figure.frame_() ) ) {

              // Change the transformDoc of the config
              const transformDoc = Matrix.m( transformModel, docToModelMatrix(docIsland,modelIsland) );
              const figureView = view.figureView(figure);

              if( figureView ) {
                figureView.draw( context, transformDoc, defaults({ transformDoc },config) );
              }
              else {
                console.log('[Error] FigureView is undefined');
              }

              if( view.showPin ) { // Do it as a config option
                dot(context,figure.pin,view.viewDeltaToTexture(3),transformDoc,'#ffffff','#222222',view.viewDeltaToTexture(4));
              }
            }
          }
        }

        layer.afterDraw(context,config);
      }
    }
  }
});



/** WEBPACK FOOTER **
 ** ./src/ui/canvas3d/texture-view-scene.js
 **/